export default __webpack_public_path__ + "static/media/secondary_student.179dcb34.png";